<kendo-formfield>
    <kendo-label *ngIf="label" [text]="label" [ngClass]="{'asterisk': required}"></kendo-label>
    <kendo-dropdownlist #sageItem="ngModel" [data]="sageList" [valuePrimitive]="true" fillMode="outline"
        textField="name" valueField="id" [ngModel]="selectedId" (ngModelChange)="onValueChange($event)"
        [defaultItem]="{ name: placeholder, id: null }" [popupSettings]="{ appendTo: 'component', animate: false }"
        [required]="required">
        <ng-template kendoDropDownListValueTemplate let-dataItem>
            <span [ngClass]="dataItem?.id ? 'not-placeholder' : 'placeholder'">
                {{ dataItem?.name }}
            </span>
        </ng-template>
    </kendo-dropdownlist>
    <kendo-formerror *ngIf="sageItem?.invalid && (sageItem?.dirty || sageItem?.touched)">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
        <span *ngIf="sageItem?.errors?.required">
            This field cannot be left blank
        </span>
    </kendo-formerror>
</kendo-formfield>
